import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75209898"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "editor"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "editor__footer" }, null, -1))

import { onBeforeUnmount, ref, watch, computed } from 'vue';
import { EditorContent, Editor } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';
import Highlight from '@tiptap/extension-highlight';
import Paragraph from '@tiptap/extension-paragraph';
import MenuBar from './MenuBar.vue';

// Props definition with type annotation

export default /*#__PURE__*/_defineComponent({
  __name: 'TiptapEditor',
  props: {
    content: {}
  },
  emits: ['update', 'blur',],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

const editor = ref<Editor>(new Editor({
    content: props.content,
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      // emit is now a global method within setup
      emit('update', html);
    },
    onBlur: ({ editor }) => {
      const html = editor.getHTML();
      emit('blur', html);
    },
    editorProps: {
      attributes: {
        class: 'acteditor',
      },
    },
    extensions: [
      Highlight,
      StarterKit,
      Paragraph.configure({
        HTMLAttributes: {
          class: 'text-justify',
        },
      }),
    ],
  }));

// Before unmount lifecycle hook
onBeforeUnmount(() => {
  editor.value.destroy();
});

// In Vue 3 setup, the component instance (`this`) is not available, so direct property access is used.

return (_ctx: any,_cache: any) => {
  return (editor.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(MenuBar, {
          class: "editor__header",
          editor: editor.value
        }, null, 8, ["editor"]),
        _createVNode(_unref(EditorContent), {
          class: "editor__content",
          editor: editor.value
        }, null, 8, ["editor"]),
        _hoisted_2
      ]))
    : _createCommentVNode("", true)
}
}

})